import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const avatarUrl = (picture) => (!picture ? undefined : picture.startsWith("http") ? picture : `${BACKEND_URL}${picture}`);

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export async function downloadFile(path, fallbackName = "download", { method = "GET", body } = {}) {
  const res = await api.request({ url: path, method, data: body, responseType: "blob" });
  const cd = res.headers["content-disposition"] || "";
  const name = /filename="?([^";]+)"?/.exec(cd)?.[1] || fallbackName;
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
  return name;
}

export async function blobErrorDetail(e) {
  const b = e?.response?.data;
  if (b instanceof Blob) { try { return formatApiErrorDetail(JSON.parse(await b.text()).detail); } catch { return `Download failed (${e.response.status})`; } }
  return formatApiErrorDetail(b?.detail) || e?.message;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail.message === "string")
    return Array.isArray(detail.missing) && detail.missing.length
      ? `${detail.message}: ${detail.missing.slice(0, 3).join("; ")}`
      : detail.message;
  return String(detail);
}
